<template>
  <chart-card :loading="loading" :title="$t('message.views.workbench.totalProductSold')" :total="productSoldData.allSoldQuantity | NumberFormat">
    <a-tooltip :title="$t('message.views.workbench.dashboardDescription.totalProductSoldQuantity')" slot="action">
      <a-icon type="info-circle-o" />
    </a-tooltip>
    <div>
      <mini-area :data-source="productSoldData.latestSoldQuantity"/>
    </div>
    <template slot="footer">{{$t('message.views.workbench.dailyProductSold')}}<span> {{ productSoldData.dailySoldQuantity | NumberFormat }}</span></template>
  </chart-card>
</template>

<script>
import request from '../../../utils/request'
import {
  ChartCard,
  MiniArea
} from '../../../components'
export default {
  name: 'AllProductSold',
  data () {
    return {
      productSoldData: {},
      loading: true
    }
  },
  mounted () {
    this.getAllProductSoldData()
    setTimeout(() => {
      this.loading = !this.loading
    }, 1000)
  },
  components: {
    ChartCard,
    MiniArea
  },
  methods: {
    getAllProductSoldData () {
      request({
        url: '/dashboard/productSold',
        method: 'get'
      }).then(response => {
        // response.data = json
        this.productSoldData = response.data.model
        this.productSoldData.latestSoldQuantity = this.productSoldData.latestSoldQuantity && this.productSoldData.latestSoldQuantity.map((item) => {
          return {
            date: item.date,
            num: Number.parseInt(item.num)
          }
        })
        console.log('productSoldData.latestSoldQuantity', this.productSoldData.latestSoldQuantity)
      })
    }
  }
}
</script>

<style  scoped>

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/components/AllProductSold.vue